import { render, staticRenderFns } from "./BasicInfo.vue?vue&type=template&id=2eb880fb&scoped=true"
import script from "./BasicInfo.vue?vue&type=script&lang=ts"
export * from "./BasicInfo.vue?vue&type=script&lang=ts"
import style0 from "./BasicInfo.vue?vue&type=style&index=0&id=2eb880fb&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2eb880fb",
  null
  
)

export default component.exports